'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');

var _require = require('react-dnd');

var DragDropMixin = _require.DragDropMixin;

var DROP_ITEM_TYPE = 'team_item';

var AssignedTeamItem = React.createClass({
  displayName: 'AssignedTeamItem',

  mixins: [DragDropMixin],

  statics: {
    configureDragDrop: function configureDragDrop(registerType) {
      registerType(DROP_ITEM_TYPE, {
        dragSource: {
          beginDrag: function beginDrag(component) {
            return {
              item: component.props.team
            };
          },
          endDrag: function endDrag(component, effect) {
            if (!effect) {
              var _component$props = component.props;
              var team = _component$props.team;
              var onUnassign = _component$props.onUnassign;

              if (onUnassign) {
                onUnassign(team);
              }
            }
          }
        }
      });
    }
  },

  render: function render() {
    var team = this.props.team;

    var _getDragState = this.getDragState(DROP_ITEM_TYPE);

    var isDragging = _getDragState.isDragging;

    return React.createElement(
      'div',
      _extends({}, this.dragSourceFor(DROP_ITEM_TYPE), {
        className: 'item-component assigned-team-item-component' }),
      React.createElement(
        'div',
        { className: 'title' },
        team.name
      ),
      React.createElement(
        'div',
        { className: 'right-decoration' },
        React.createElement(
          'div',
          { className: 'inline-dropdown-component' },
          React.createElement(
            'select',
            { ref: 'permission', value: team.permission, onChange: this._onPermissionChange },
            React.createElement(
              'option',
              { value: 'readwrite' },
              'Read & Write'
            ),
            React.createElement(
              'option',
              { value: 'readonly' },
              'Read Only'
            )
          )
        )
      )
    );
  },

  _onPermissionChange: function _onPermissionChange(evt) {
    var props = this.props;
    var refs = this.refs;
    var team = props.team;
    var onPermissionChange = props.onPermissionChange;
    var value = refs.permission.value;

    if (onPermissionChange) {
      onPermissionChange(team.id, value);
    }
  }
});

module.exports = AssignedTeamItem;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/datasource/assigned-team-item.js
 **/